import { render, staticRenderFns } from "./select-datasource-modal.component.vue?vue&type=template&id=7b20439c&scoped=true&"
import script from "./select-datasource-modal.component.vue?vue&type=script&lang=ts&"
export * from "./select-datasource-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./select-datasource-modal.component.vue?vue&type=style&index=0&id=7b20439c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b20439c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
